<nav>
  @for (link of links; track link; let last = $last) {
    @if (link.url || (link.routerLink ?? []).length > 0) {
      @if (link.url) {
        <a class="re-standalone" [href]="link.url">{{ link.text }}</a>
      }
      @if (link.routerLink) {
        <a
          class="re-standalone"
          [routerLink]="link.routerLink"
          [queryParams]="link.queryParams"
          [fragment]="link.fragment"
          >{{ link.text }}</a
        >
      }
    }
    @if (!link.url && (link.routerLink ?? []).length === 0) {
      <h5>{{ link.text }}</h5>
    }
    @if (!last) {
      <img
        src="assets/images/cmi-icons/icon-reg_chevron-right.svg"
        alt="Chevron Right"
        height="16" />
    }
  }
</nav>
